import Row from '@totallymoney/ui/components/Row'
import ProductInformationBox from '@totallymoney/ui/productTable/components/ProductInformationBox'

import { UnscoredLoanProduct } from '@appTypes/LoansApi.interface'

import formatNumberToCurrency from '@utils/formatNumberToCurrency'

const UnscoredTableItemProductInfoSection = ({
    item,
}: {
    item: UnscoredLoanProduct
}) => (
    <Row
        display="grid"
        gridTemplateColumns={[
            'repeat(2, minmax(110px, 1fr))',
            'repeat(auto-fill, minmax(160px, 170px))',
            'repeat(auto-fill, 170px)',
        ]}
        flexWrap="wrap"
        space="space05"
    >
        <ProductInformationBox
            text="Representative APR (fixed)"
            heading={`${item.apr}% APR`}
            variant="neutral"
        />

        <ProductInformationBox
            text="Monthly repayment"
            heading={formatNumberToCurrency(item.monthlyPayment, '$0,0[.]00')}
            variant="neutral"
        />

        <ProductInformationBox
            text="Total charge for credit"
            heading={formatNumberToCurrency(item.totalCharge, '$0,0[.]00')}
            variant="neutral"
        />

        <ProductInformationBox
            text="Total amount repayable"
            heading={formatNumberToCurrency(item.totalRepayable, '$0,0[.]00')}
            variant="neutral"
        />
    </Row>
)

export default UnscoredTableItemProductInfoSection
